/**
 * SOLID Review
 * S — Strong. One schema: the request context every client port op takes first.
 * O — Strong. A new context field is one optional key here.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. One schema, one derived type.
 * D — Good. zod and the shared primitives only.
 */
import { z } from 'zod';
import { Identifier } from './primitives';

/**
 * THE CONTEXT EVERY CLIENT PORT CALL CARRIES FIRST (frontend strict-ports plan, FE1). The backend's
 * `ContextRequest` minus what only a server has: no `txId` (the client has no unit of work) and no
 * `traceparent` yet (joining client and server traces is deferred — plan "Deferred"). Minted by the
 * Framework's `ClientRequests`, as the backend's `RequestContexts` mints its own.
 *
 * Registered under the SAME id as the backend's on purpose: it is the same idea, and the two contract
 * documents are read side by side.
 */
export const ContextRequest = z.object({
  requestId: Identifier,
  deadlineAt: z.number().int().positive(),
}).meta({ id: 'ContextRequest' });

export type IContextRequest = z.infer<typeof ContextRequest>;
